"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonSizes = exports.buttonTypes = exports.buttonModel = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Helper to extract needed fields from ButtonLink Contentful model
 * @param {Object} model Contentful model for button link
 */
var buttonModel = function buttonModel(model) {
  return model ? {
    props: {
      type: _lodash["default"].get(model, 'fields.type'),
      size: _lodash["default"].get(model, 'fields.size')
    },
    text: _lodash["default"].get(model, 'fields.text')
  } : null;
};

exports.buttonModel = buttonModel;
var buttonTypes = {
  primary: 'primary',
  secondary: 'secondary',
  "default": 'default',
  text: 'text'
};
exports.buttonTypes = buttonTypes;
var buttonSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.buttonSizes = buttonSizes;